import { inject, Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';
import { EndPoints } from '@services/EndPoints';
import { GetHolidaysParams, GetHolidaysResponse, Holiday } from '../dtos/holidays.dto';

@Injectable({ providedIn: 'root' })
export class HolidaysProvider {
  private readonly api = inject(ApiService);

  // In-memory cache: 'country|province|city|year-month' → Holiday[]
  // Survives modal open/close — persists while the app session lives
  private cache = new Map<string, Holiday[]>();

  async getHolidays(params: GetHolidaysParams): Promise<Holiday[]> {
    const cacheKey = `${params.country}|${params.province}|${params.city}|${params.year}-${params.month || 'all'}`;

    if (this.cache.has(cacheKey)) {
      return this.cache.get(cacheKey)!;
    }

    try {
      const queryParams: Record<string, string | number | boolean | undefined> = {};
      if (params.country) queryParams['country'] = params.country;
      if (params.province) queryParams['province'] = params.province;
      if (params.city) queryParams['city'] = params.city;
      queryParams['year'] = params.year;
      if (params.month) queryParams['month'] = params.month;

      const response = await this.api.get<GetHolidaysResponse>({
        url: EndPoints.holidays,
        queryParams
      });

      const holidays = response?.holidays || [];
      this.cache.set(cacheKey, holidays);
      return holidays;
    } catch (error) {
      console.warn('Error loading holidays:', error);
      return []; // Error tolerance — empty array, calendars are unaffected
    }
  }
}
